"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SettingsButton = void 0;
const preact_1 = require("preact");
const typestyle_1 = require("typestyle");
const Game_1 = require("../../../Game");
const style_1 = require("./style");
const Controls_style_1 = require("../../Controls.style");
class SettingsButton extends preact_1.Component {
    constructor(props) {
        super(props);
        this.onSpeedModeClick = () => {
            if (this.props.game.mode === Game_1.PlayerMode.FREE) {
                return;
            }
            this.props.game.isSpeedVisible = !this.props.game.isSpeedVisible;
        };
        this.onFpsModeClick = () => {
            if (this.props.game.mode === Game_1.PlayerMode.FREE) {
                return;
            }
            this.props.game.isFpsVisible = !this.props.game.isFpsVisible;
        };
        this.onButtonsModeClick = () => {
            if (this.props.game.mode === Game_1.PlayerMode.FREE) {
                return;
            }
            this.props.game.isButtonsVisible = !this.props.game.isButtonsVisible;
        };
        this.onStrafesModeClick = () => {
            if (this.props.game.mode === Game_1.PlayerMode.FREE) {
                return;
            }
            this.props.game.isStrafesVisible = !this.props.game.isStrafesVisible;
        };
        this.toggleMenu = () => {
            this.setState({ isOpen: !this.state.isOpen });
        };
        this.state = {
            isOpen: false
        };
    }
    render() {
        return ((0, preact_1.h)("div", { class: style_1.SettingsButtonStyle.settings },
            (0, preact_1.h)("div", { class: (0, typestyle_1.classes)(Controls_style_1.ControlsStyle.button, style_1.SettingsButtonStyle.button), title: "Display options", onClick: this.toggleMenu },
                (0, preact_1.h)("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 24 24" },
                    (0, preact_1.h)("path", { fill: "#ffffff", d: "M12 5C6.3 5 1.7 9.1 0 12c1.7 2.9 6.3 7 12 7s10.3-4.1 12-7c-1.7-2.9-6.3-7-12-7zm0 11.2A4.2 4.2 0 1 1 12 7.8a4.2 4.2 0 0 1 0 8.4zm0-2.2a2 2 0 1 0 0-4 2 2 0 0 0 0 4z" }))),
            (0, preact_1.h)("div", { class: this.state.isOpen ? style_1.SettingsButtonStyle.menuOpen : style_1.SettingsButtonStyle.menu },
                (0, preact_1.h)("span", { class: style_1.SettingsButtonStyle.menuItemTitle }, "Toggle Display"),
                (0, preact_1.h)("span", { class: this.props.game.isSpeedVisible === true
                        ? style_1.SettingsButtonStyle.menuItemSelected
                        : style_1.SettingsButtonStyle.menuItem, onClick: this.onSpeedModeClick }, "Speed"),
                (0, preact_1.h)("span", { class: this.props.game.isFpsVisible === true
                        ? style_1.SettingsButtonStyle.menuItemSelected
                        : style_1.SettingsButtonStyle.menuItem, onClick: this.onFpsModeClick }, "Fps"),
                (0, preact_1.h)("span", { class: this.props.game.isButtonsVisible === true
                        ? style_1.SettingsButtonStyle.menuItemSelected
                        : style_1.SettingsButtonStyle.menuItem, onClick: this.onButtonsModeClick }, "Keys"),
                (0, preact_1.h)("span", { class: this.props.game.isStrafesVisible === true
                        ? style_1.SettingsButtonStyle.menuItemSelected
                        : style_1.SettingsButtonStyle.menuItem, onClick: this.onStrafesModeClick }, "Stats"))));
    }
}
exports.SettingsButton = SettingsButton;
